<template>
    <div class="p-4">
    <vs-switch
        id="feature-details-table-switch-button"
        v-model="params.data.features_enabled"
        @input="toggleForAccount(params.data)"/>
    </div>
</template>


<script>
export default {

  methods: {
    async toggleForAccount (account) {
      await window.axios.post(`/features/${this.$route.params.id}/${account.id}/toggle/${account.features_enabled ? 'enable' : 'disable'}`)
      this.params.node.setData({
        ...this.params.node.data,
        features_enabled: account.features_enabled
      })
      this.$nextTick(() => {
        this.params.api.refreshCells({
          rowNodes: [this.params.node],
          force: true
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
